import { render, staticRenderFns } from "./PrivacyPolicy2014.vue?vue&type=template&id=8ff657b2&"
import script from "./PrivacyPolicy2014.vue?vue&type=script&lang=ts&"
export * from "./PrivacyPolicy2014.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('8ff657b2', component.options)
    } else {
      api.reload('8ff657b2', component.options)
    }
    module.hot.accept("./PrivacyPolicy2014.vue?vue&type=template&id=8ff657b2&", function () {
      api.rerender('8ff657b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/flatpages/PrivacyPolicy2014.vue"
export default component.exports